import { create } from 'zustand';
import type { Meeting, User } from '../types';

interface AppState {
  // Selected operator (for admins viewing other operators)
  selectedOperator: User | null;
  setSelectedOperator: (operator: User | null) => void;

  // Active meeting (for quick access)
  activeMeeting: Meeting | null;
  setActiveMeeting: (meeting: Meeting | null) => void;

  // UI State
  isSidebarOpen: boolean;
  toggleSidebar: () => void;
  setSidebarOpen: (open: boolean) => void;

  // Notification permission
  notificationPermission: NotificationPermission;
  setNotificationPermission: (permission: NotificationPermission) => void;
  requestNotificationPermission: () => Promise<void>;
}

export const useAppStore = create<AppState>((set) => ({
  selectedOperator: null,
  setSelectedOperator: (operator) => set({ selectedOperator: operator }),

  activeMeeting: null,
  setActiveMeeting: (meeting) => set({ activeMeeting: meeting }),

  isSidebarOpen: false,
  toggleSidebar: () => set((state) => ({ isSidebarOpen: !state.isSidebarOpen })),
  setSidebarOpen: (open) => set({ isSidebarOpen: open }),

  notificationPermission: 'default',
  setNotificationPermission: (permission) => set({ notificationPermission: permission }),

  requestNotificationPermission: async () => {
    if (!('Notification' in window)) {
      console.log('This browser does not support notifications');
      return;
    }

    try {
      const permission = await Notification.requestPermission();
      set({ notificationPermission: permission });

      if (permission === 'granted') {
        console.log('Notification permission granted');
      } else {
        console.log('Notification permission denied');
      }
    } catch (error) {
      console.error('Error requesting notification permission:', error);
    }
  },
}));
